module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/4-f0757c6868d501809ef23f1a7136336a.svg";